import {SHARED_ROUTES} from '@/shared/constants/routes';

export const ROUTES = {
  HOME: '/home',
  SETTING: '/home/setting',
  RECOMMEND_CODE: '/home/:recommendCode',
  HOME_DELETE: '/home/delete',

  CARD_GROUP: '/detail/:groupCode',
  CARD_GROUP_DELETE: '/detail/:groupCode/delete',
  CARD_LIST: '/detail/:groupCode/cards',
  CARD_DETAIL: '/detail/:groupCode/:cardId',
  CARD_GROUP_BY_CARD_ID: '/detail/group/:cardId',
  CARD_NOT_FOUND: '/detail/card-not-found',
  PAPAS_BRIDGE: '/papas-bridge/:groupCode',
  INVALID_VERSION: SHARED_ROUTES.INVALID_VERSION,
  NOT_FOUND: SHARED_ROUTES.NOT_FOUND,
  LOGIN_ERROR: SHARED_ROUTES.LOGIN_ERROR,
  NETWORK_ERROR: SHARED_ROUTES.NETWORK_ERROR,
  SERVER_ERROR: SHARED_ROUTES.SERVER_ERROR,
  FOREIGNER: SHARED_ROUTES.FOREIGNER,
  UNDER_MAINTENANCE: SHARED_ROUTES.UNDER_MAINTENANCE,
  INVALID_DEVICE: SHARED_ROUTES.INVALID_DEVICE
} as const;
